/** The modifier state of a pointer or keyboard event. */
interface ModifierState {
  metaKey: boolean;
  ctrlKey: boolean;
  altKey: boolean;
}

/** Holding Cmd (Ctrl on Windows) suspends snapping, on the canvas and on the timeline alike (the design-tool convention). */
export const isSnapSuspendModifierHeld = (event: Pick<ModifierState, 'metaKey' | 'ctrlKey'>): boolean => {
  return event.metaKey || event.ctrlKey;
};

/** Holding Alt (Option on a Mac) shows the selected item's distance to each canvas edge. */
export const isDistanceReadoutModifierHeld = (event: Pick<ModifierState, 'altKey'>): boolean => {
  return event.altKey;
};
